/**
 * FriendsListSkeleton - Skeleton loader for friends list
 */

import React from 'react';

export const FriendsListSkeleton: React.FC = () => {
  return (
    <div className="space-y-3">
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="bg-white rounded-lg border border-gray-200 p-4 animate-pulse"
        >
          <div className="flex items-center space-x-4">
            {/* Avatar skeleton */}
            <div className="h-12 w-12 rounded-full bg-gray-200 flex-shrink-0"></div>
            
            {/* Content skeleton */}
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-3 bg-gray-200 rounded w-1/2"></div>
            </div>
            
            {/* Badge skeleton */}
            <div className="h-6 w-16 bg-gray-200 rounded-full flex-shrink-0"></div>
          </div>
        </div>
      ))}
    </div>
  );
};
